import React from "react";
import firebase from "firebase/app";

const provider = new firebase.auth.GoogleAuthProvider();

class SignIn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showEmail: true,
    };
  }

  componentDidMount() {
    if (window.localStorage.getItem("clickedGoogleSignin")) {
      this.setState({ showEmail: true });
    }
  }

  googleSignIn = (event) => {
    window.localStorage.setItem("clickedGoogleSignin", true);
    window.location.hash = "redirect";
    firebase.auth().signInWithRedirect(provider);
  };

  render() {
    let emailUrl = "/email-sign-in";
    if (this.props.next) {
      emailUrl += "?next=" + this.props.next;
    }

    return (
      <div id="center-box">
        <div className="inner">
          <h1>{this.props.title ? this.props.title : "Sudowrite"}</h1>
          <p dangerouslySetInnerHTML={{ __html: this.props.description ? this.props.description : "Sign In or Sign Up" }}></p>

          {this.props.error && <p className="error">{this.props.error}</p>}

          <button
            className="google"
            onClick={this.googleSignIn}
          ></button>

          {this.state.showEmail && (
            <p className="trouble">
              <a href={emailUrl}>No Google account? Having trouble?</a>
            </p>
          )}
        </div>
      </div>
    );
  }
}

export default SignIn;
